import type { FaireProductEntity } from "../../entity_types/product";

export const p_49rwssyr8d: FaireProductEntity = {
  token: "p_49rwssyr8d",
  type: "product",
  name: "Juliana 18K Gold Non-Tarnish Flat Bold Snake Chain Necklace",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/e701f97897f35a67ca6d6c7c9bd8f914602ae64c1a9c1f6230a62db04598df41.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/24f6b068e97c1c56f3e24afb26187205720575f44ff80d7ecc2477e5d9d5d830.jpeg",
    "https://cdn.faire.com/fastly/040022d90bf4599721fd60d604eedbdfc09ae526ed909e004c9a0876b9567675.jpeg",
    "https://cdn.faire.com/fastly/4eccaec651b047fc3b5bc36fc21381a00604201f535c3afc52d2b3aa3c374c52.jpeg",
  ],
  priceDollars: 11.31,
  description:
    '18K Gold Non-Tarnish Flat Bold Snake Chain Necklace\n\n18K Gold Plated\nStainless Steel\nChain Length (inch): 16\nExtension Length (inch): 3"\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant',
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:34.942Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
